<template>
    <div class="row">
        <div class="col-6">
            <div class="form-group m-0">
                <button type="reset" @click="onCancel" class="btn btn_primary-outline pl-5 pr-5">
                    <span>Cancel</span>
                </button>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group m-0 text-right">
                <button type="submit" @click.prevent="onSave" class="btn btn_golden">
                    <span class="pl-5 pr-5">Save</span>
                </button>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: "BaseButtons",
    props: {
        onCancel: {
            type: Function,
            required: false,
            default: () => () => {}
        },
        onSave: {
            type: Function,
            required: false,
            default: () => () => {}
        }
    }

}
</script>

<style scoped>

</style>
